var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{attrs:{"src":require("@/assets/icons/ihm_icon.jpg"),"alt":"international healthcare media icon"}})
}
var staticRenderFns = []

export { render, staticRenderFns }